export default __webpack_public_path__ + "static/media/About1.76e1397e.jpeg";